import React from 'react';
import { Dropdown, DropdownItem } from '@amzn/storm-ui';
import { StyledFormRow, FieldContainer } from './EditInventoryForm.styles';
import { DropdownFieldProps } from '../../interfaces/formField.interfaces';

export const DropdownField = ({
  label,
  value,
  onChange,
  disabled,
  placeholder,
  items,
}: DropdownFieldProps) => (
  <StyledFormRow
    id={label}
    label={label}
    controlComponents={[
      () => (
        <FieldContainer>
          <Dropdown
            selectedValue={value || undefined}
            onChange={onChange}
            disabled={disabled}
            fullWidth
          >
            {placeholder && (
              <DropdownItem value="" disabled>
                {placeholder}
              </DropdownItem>
            )}
            {items.map((item) => (
              <DropdownItem key={item.key} value={item.value}>
                {item.label}
              </DropdownItem>
            ))}
          </Dropdown>
        </FieldContainer>
      ),
    ]}
  />
);
